module.exports = [
	{
		"name": "Please select...",
		"value": "",
		"subCategories": []
	},
	{
		"name": "Problems with my broadband",
		"value": "Problems with my broadband",
		"subCategories": [
			{
				"name": "Please select...",
				"value": ""
			},
			{
				"name": "No connection",
				"value": "No connection",
				"customFields": [
					{
						"fieldType": "modem-select",
						"id": "modem-select",
						"name": "widgetMode",
						"isRequired": true,
						"label": "Which type of Skinny Modem do you have?"
					},
					{
						"fieldType": "plaintext",
						"id": "modem-ready",
						"cssClass": "contact-us-subheading",
						"value": "Before you answer these questions, please ensure your modem has been connected up, and turned on for at least 5 minutes"
					},
					{
						"fieldType": "modem-lights",
						"id": "PowerLight",
						"name": "PowerLight",
						"label": "Power Light",
						"isRequired": true,
						"message": "What are the lights on your modem doing?"
					},
					{
						"fieldType": "modem-lights",
						"id": "WanLight",
						"name": "WanLight",
						"label": "WAN Light",
						"isRequired": true
					},
					{
						"fieldType": "modem-lights",
						"id": "InternetLight",
						"name": "InternetLight",
						"label": "Internet Light",
						"isRequired": true
					},
					{
						"fieldType": "modem-lights",
						"id": "WLANLight",
						"name": "WLANLight",
						"label": "WLAN Light",
						"isRequired": true
					},
					{
						"fieldType": "smart-modem-status",
						"id": "smart-modem-status",
						"name": "SmartModemLight",
						"label": "Smart Modem Light",
						"isRequired": true,
						"cssClass": "contact-us-normal-text",
						"message": "What is the light on your modem doing?"
					},
					{
						"fieldType": "choice",
						"id": "ConnectionEverWorked",
						"name": "ConnectionEverWorked",
						"label": "Has your connection worked before at this address?",
						"isRequired": true,
						"choices": [
							{
								"id": "connectionEverWorkedYes",
								"value": "Yes"
							},
							{
								"id": "connectionEverWorkedNo",
								"value": "No"
							}
						]
					},
					{
						"fieldType": "textarea",
						"id": "message",
						"name": "message",
						"label": "Tell us about any other details including any steps you have taken to fix your connection",
						"placeholder": "e.g. I have reset my modem and tried it at different jackpoints, but can't get online.",
						"autotestClass": "autotest-message",
						"maxLength": 1000,
						"rows": 8,
						"isRequired": true
					},
					{
						"fieldType": "submit-button",
						"id": "contactUsSubmitButton"
					}
				]
			},
			{
				"name": "Slow connection",
				"value": "Slow connection",
				"customFields": [
					{
						"fieldType": "plaintext",
						"id": "modem-ready",
						"cssClass": "contact-us-subheading",
						"value": "Before you answer these questions, please ensure your modem has been connected up, and turned on for at least 5 minutes"
					},
					{
						"fieldType": "choice",
						"id": "connectingToModem",
						"name": "connectingToModem",
						"label": "How are you connected to your modem?",
						"isRequired": true,
						"choices": [
							{
								"id": "connectingToModemWiFi",
								"value": "WiFi"
							},
							{
								"id": "connectingToModemNetworkCable",
								"value": "Network cable"
							},
							{
								"id": "connectingToModemUnknown",
								"value": "I don't know"
							}
						]
					},
					{
						"fieldType": "choice",
						"id": "reducedSpeed",
						"name": "reducedSpeed",
						"label": "When do you notice reduced speeds?",
						"isRequired": true,
						"choices": [
							{
								"id": "reducedSpeedMorning",
								"value": "Morning"
							},
							{
								"id": "reducedSpeedAfternoon",
								"value": "Afternoon"
							},
							{
								"id": "reducedSpeedEvening",
								"value": "Evening"
							},
							{
								"id": "reducedSpeed247",
								"value": "All the time"
							}
						]
					},
					{
						"fieldType": "choice",
						"id": "anythingElseUsingInternet",
						"name": "anythingElseUsingInternet",
						"label": "When you notice reduced speed, is anything else using your internet connection?",
						"isRequired": true,
						"choices": [
							{
								"id": "anythingElseUsingInternetYes",
								"value": "Yes"
							},
							{
								"id": "anythingElseUsingInternetNo",
								"value": "No"
							}
						]
					},
					{
						"fieldType": "textarea",
						"id": "message",
						"name": "message",
						"label": "Tell us about any other details including any steps you have taken to fix your connection",
						"placeholder": "e.g. I've made sure my flatmate isn't uploading to the cloud and swapped my computer from WiFi to a Network cable, but am still getting slow speeds.",
						"autotestClass": "autotest-message",
						"maxLength": 1000,
						"rows": 8,
						"isRequired": true
					},
					{
						"fieldType": "submit-button",
						"id": "contactUsSubmitButton"
					}
				]
			},
			{
				"name": "Regular dropouts",
				"value": "Regular dropouts",
				"customFields": [
					{
						"fieldType": "modem-select",
						"id": "modem-select",
						"name": "widgetMode",
						"isRequired": true,
						"label": "Which type of Skinny Modem do you have?"
					},
					{
						"fieldType": "plaintext",
						"id": "modem-ready",
						"cssClass": "contact-us-subheading",
						"value": "Before you answer these questions, please ensure your modem has been connected up, and turned on for at least 5 minutes"
					},
					{
						"fieldType": "choice",
						"id": "reducedSpeed",
						"name": "reducedSpeed",
						"label": "When do you notice drop outs on your connection?",
						"isRequired": true,
						"choices": [
							{
								"id": "dropoutsInMorning",
								"value": "Morning"
							},
							{
								"id": "dropoutsInAfternoon",
								"value": "Afternoon"
							},
							{
								"id": "dropoutsInEvening",
								"value": "Evening"
							},
							{
								"id": "dropoutsIn247",
								"value": "All the time"
							}
						]
					},
					{
						"fieldType": "modem-lights",
						"id": "WanLight",
						"name": "WanLight",
						"label": "WAN Light",
						"isRequired": true,
						"message": "When your connection drops out what does the WAN light on the modem do?"
					},
					{
						"fieldType": "smart-modem-status",
						"id": "smart-modem-status",
						"name": "SmartModemLight",
						"label": "Smart Modem Status",
						"isRequired": true,
						"message": "When your connection drops out what does the light on the modem do?",
						"cssClass": "contact-us-normal-text"
					},
					{
						"fieldType": "choice",
						"id": "anythingElseUsingInternet",
						"name": "anythingElseUsingInternet",
						"label": "When your connection drops out is there anything else using your internet connection?",
						"isRequired": true,
						"choices": [
							{
								"id": "anythingElseUsingInternetYes",
								"value": "Yes"
							},
							{
								"id": "anythingElseUsingInternetNo",
								"value": "No"
							}
						]
					},
					{
						"fieldType": "textarea",
						"id": "message",
						"name": "message",
						"label": "Tell us about any other details including any steps you have taken to fix your connection",
						"placeholder": "e.g. I've made sure my flatmate isn't uploading to the cloud and have swapped my computer from WiFi to a Network cable, but my connection still drops out.",
						"autotestClass": "autotest-message",
						"maxLength": 1000,
						"rows": 8,
						"isRequired": true
					},
					{
						"fieldType": "submit-button",
						"id": "contactUsSubmitButton"
					}
				]
			}
		]
	},
	{
		"name": "My account",
		"value": "My account",
		"subCategories": [
			{
				"name": "Please select...",
				"value": ""
			},
			{
				"name": "Change credit/debit card",
				"value": "Change credit/debit card",
				"customFields": [
					{
						"fieldType": "plaintext",
						"id": "paymentCardMessage",
						"cssClass": "contact-us-messages",
						"name": "paymentCardMessage",
						"value": "It’s super easy to change your credit/debit card - just ",
						"linkTo": "/dashboard",
						"linkDescription": "Login to your Dashboard",
						"textAfterLink": " and click on change card.",
						"autotestClass": "test-change_cc_link"
					}
				]
			},
			{
				"name": "Billing and payment",
				"value": "Billing and payment",
				"customFields": [
					{
						"fieldType": "textarea",
						"id": "message",
						"name": "message",
						"label": "Tell us a bit more about your billing issue",
						"placeholder": "Enter your message here.",
						"autotestClass": "autotest-message",
						"maxLength": 1000,
						"rows": 8,
						"isRequired": true
					},
					{
						"fieldType": "submit-button",
						"id": "contactUsSubmitButton"
					}
				]
			},
			{
				"name": "Follow up on previous requests",
				"value": "Follow up on previous requests",
				"customFields": [
					{
						"fieldType": "textarea",
						"id": "message",
						"name": "message",
						"label": "Let us know how we can help.",
						"placeholder": "Enter your message here.",
						"autotestClass": "autotest-message",
						"maxLength": 1000,
						"rows": 8,
						"isRequired": true
					},
					{
						"fieldType": "submit-button",
						"id": "contactUsSubmitButton"
					}
				]
			},
			{
				"name": "Change my email or mobile number",
				"value": "Change my email or mobile number",
				"customFields": [
					{
						"fieldType": "textarea",
						"id": "message",
						"name": "message",
						"label": "Let us know what you'd like to change",
						"placeholder": "Enter your message here.",
						"autotestClass": "autotest-message",
						"maxLength": 1000,
						"rows": 8,
						"isRequired": true
					},
					{
						"fieldType": "submit-button",
						"id": "contactUsSubmitButton"
					}
				]
			},
			{
				"name": "Upgrade to Fibre",
				"value": "Upgrade to Fibre",
				"customFields": [
					{
						"fieldType": "plaintext",
						"id": "upgradeToFibreMessage",
						"cssClass": "contact-us-messages",
						"name": "upgradeToFibreMessage",
						"value": "It’s super easy to upgrade to Fibre from the Skinny Dashboard. Just ",
						"linkTo": "/dashboard",
						"linkDescription": "Login",
						"textAfterLink": " and click on Upgrade to Fibre.",
						"autotestClass": "autotest-loginLink"
					}
				]
			},
			{
				"name": "Change Fibre Speed",
				"value": "Change Fibre Speed",
				"customFields": [
					{
						"fieldType": "plaintext",
						"id": "changeSpeedMessage",
						"cssClass": "contact-us-messages",
						"name": "changeSpeedMessage",
						"value": "It’s super easy to change your speed from the Skinny Dashboard. Just ",
						"linkTo": "/dashboard",
						"linkDescription": "Login",
						"textAfterLink": " and click on Change Speed.",
						"autotestClass": "autotest-loginLink"
					}
				]
			},
			{
				"name": "Change my connection address",
				"value": "Change my connection address",
				"customFields": [
					{
						"fieldType": "plaintext",
						"id": "moveAddressMessage",
						"cssClass": "contact-us-messages",
						"name": "moveAddressMessage",
						"value": "Moving house? No worries. Your broadband can move with you. Just ",
						"linkTo": "/dashboard",
						"linkDescription": "Login",
						"textAfterLink": " to your Dashboard and click on Move Address.",
						"autotestClass": "autotest-loginLink"
					}
				]
			},
			{
				"name": "Cancelling my Skinny connection",
				"value": "Cancelling my Skinny connection",
				"customFields": [
					{
						"fieldType": "textarea",
						"id": "message",
						"name": "message",
						"label": "Let us know why you're looking to cancel",
						"placeholder": "Enter your message here.\nPlease be sure to confirm the date you'd like to disconnect, as well as the physical address you're connected at.",
						"autotestClass": "autotest-message",
						"maxLength": 1000,
						"rows": 8,
						"isRequired": true
					},
					{
						"fieldType": "submit-button",
						"id": "contactUsSubmitButton"
					}
				]
			},
			{
				"name": "Renew my plan",
				"value": "Renew my plan",
				"customFields": [
					{
						"fieldType": "textarea",
						"id": "message",
						"name": "message",
						"label": "Tell us a bit more about your renew issue",
						"placeholder": "Enter your message here.",
						"autotestClass": "autotest-message",
						"maxLength": 1000,
						"rows": 8,
						"isRequired": true
					},
					{
						"fieldType": "submit-button",
						"id": "contactUsSubmitButton"
					}
				]
			}
		]
	},
	{
		"name": "Joining Skinny",
		"value": "Joining Skinny",
		"subCategories": [
			{
				"name": "Please select...",
				"value": ""
			},
			{
				"name": "Problem Signing up",
				"value": "Problem Signing up",
				"customFields": [
					{
						"fieldType": "textarea",
						"id": "message",
						"name": "message",
						"label": "Tell us a bit more about your problem signing up",
						"placeholder": "Enter your message here.\nPlease be sure to include your full address.",
						"autotestClass": "autotest-message",
						"maxLength": 1000,
						"rows": 8,
						"isRequired": true
					},
					{
						"fieldType": "submit-button",
						"id": "contactUsSubmitButton"
					}
				]
			},
			{
				"name": "Status of my order",
				"value": "Status of my order",
				"customFields": [
					{
						"fieldType": "textarea",
						"id": "message",
						"name": "message",
						"label": "Tell us a bit more about your query",
						"placeholder": "Enter your message here.",
						"autotestClass": "autotest-message",
						"maxLength": 1000,
						"rows": 8,
						"isRequired": true
					},
					{
						"fieldType": "submit-button",
						"id": "contactUsSubmitButton"
					}
				]
			},
			{
				"name": "Change my connection date",
				"value": "Change my connection date",
				"customFields": [
					{
						"fieldType": "textarea",
						"id": "message",
						"name": "message",
						"label": "Tell us more more about changing your connection date",
						"placeholder": "Enter your message here.",
						"autotestClass": "autotest-message",
						"maxLength": 1000,
						"rows": 8,
						"isRequired": true
					},
					{
						"fieldType": "submit-button",
						"id": "contactUsSubmitButton"
					}
				]
			}
		]
	},
	{
		"name": "Feedback and Complaints",
		"value": "Feedback and Complaints",
		"subCategories": [
			{
				"name": "Please select...",
				"value": ""
			},
			{
				"name": "I would like to provide feedback",
				"value": "I would like to provide feedback",
				"customFields": [
					{
						"fieldType": "textarea",
						"id": "message",
						"name": "message",
						"label": "Let us know about your experience with Skinny",
						"placeholder": "Enter your feedback here.",
						"autotestClass": "autotest-message",
						"maxLength": 1000,
						"rows": 8,
						"isRequired": true
					},
					{
						"fieldType": "submit-button",
						"id": "contactUsSubmitButton"
					}
				]
			},
			{
				"name": "I would like to make a complaint",
				"value": "I would like to make a complaint",
				"customFields": [
					{
						"fieldType": "textarea",
						"id": "message",
						"name": "message",
						"label": "Let us know about your experience with Skinny",
						"placeholder": "Enter your message here.",
						"autotestClass": "autotest-message",
						"maxLength": 1000,
						"rows": 8,
						"isRequired": true
					},
					{
						"fieldType": "submit-button",
						"id": "contactUsSubmitButton"
					}
				]
			}
		]
	},
	{
		"name": "Christmas gift",
		"value": "Christmas gift",
		"subCategories": [
			{
				"name": "Please select...",
				"value": ""
			},
			{
				"name": "General query about the Christmas gift",
				"value": "General query about the Christmas gift",
				"customFields": [
					{
						"fieldType": "plaintext",
						"id": "offerInformation",
						"cssClass": "contact-us-messages-top",
						"name": "offerInformationMessage",
						"value": "For more on the offer, product specs and our returns and repairs policy, view ",
						"linkTo": "https://www.skinny.co.nz/broadbandfreebie",
						"linkDescription": "product information",
						"textAfterLink": ".",
						"autotestClass": "test-offer-info-link"
					},
					{
						"fieldType": "plaintext",
						"id": "offerTerms",
						"cssClass": "contact-us-messages-bottom",
						"name": "offerTernsMessage",
						"value": "View Skinny ",
						"linkTo": "https://www.skinny.co.nz/skinny-terms/#PT",
						"linkDescription": "terms and conditions",
						"textAfterLink": ".",
						"autotestClass": "test-offer-info-terms-link"
					},
					{
						"fieldType": "textarea",
						"id": "message",
						"name": "message",
						"label": "Ask us a question about your Christmas gift",
						"placeholder": "Enter a question about your Christmas gift.",
						"maxLength": 1000,
						"rows": 8,
						"isRequired": true,
						"autotestClass": "autotest-message"
					},
					{
						"fieldType": "submit-button",
						"id": "contactUsSubmitButton"
					}
				]
			},
			{
				"name": "Setting up the Christmas gift",
				"value": "Setting up the Christmas gift",
				"customFields": [
					{
						"fieldType": "plaintext",
						"cssClass": "contact-us-messages",
						"id": "offerInformation",
						"name": "offerInformationMessage",
						"value": "Before you contact us please check out the ",
						"linkTo": "https://www.skinny.co.nz/broadbandfreebie",
						"linkDescription": "product information",
						"textAfterLink": ".  If you're still having problems setting up your Christmas gift, please describe the issue in detail below.",
						"autotestClass": "test-setup-use-link"
					},
					{
						"fieldType": "textarea",
						"id": "message",
						"name": "message",
						"label": "Describe the issue with your Christmas gift below",
						"placeholder": "Enter your description here.",
						"maxLength": 1000,
						"rows": 8,
						"isRequired": true,
						"autotestClass": "autotest-message"
					},
					{
						"fieldType": "submit-button",
						"id": "contactUsSubmitButton"
					}
				]
			},
			{
				"name": "My Christmas gift is not working as expected",
				"value": "My Christmas gift is not working as expected",
				"customFields": [
					{
						"fieldType": "plaintext",
						"cssClass": "contact-us-messages",
						"name": "replace-message",
						"value": "Sorry to hear you are having a problem with your Christmas gift. For steps on how to fix common problems, head to the ",
						"linkDescription": "product information",
						"linkTo": "https://www.skinny.co.nz/broadbandfreebie",
						"textAfterLink": ". If you are still having issues please fill the below form and we will get back to you.",
						"autotestClass": "test-problem-product-link"
					},
					{
						"fieldType": "text",
						"id": "address",
						"name": "address",
						"label": "Your mailing address (to send a replacement product if required)",
						"placeholder": "Enter your mailing address here",
						"maxLength": 400,
						"isRequired": true
					},
					{
						"fieldType": "text",
						"id": "serial-number",
						"name": "serial-number",
						"label": "Product serial number",
						"placeholder": "Enter your product serial number here",
						"maxLength": 100
					},
					{
						"fieldType": "textarea",
						"id": "message",
						"name": "message",
						"label": "Describe the problem",
						"placeholder": "Tell us more about the problem with your Christmas gift",
						"maxLength": 1000,
						"rows": 8,
						"isRequired": true,
						"autotestClass": "autotest-message"
					},
					{
						"fieldType": "submit-button",
						"id": "contactUsSubmitButton"
					}
				]
			}
		]
	}
];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ContactUs/ContactUsCategories.json
 ** module id = 314
 ** module chunks = 0
 **/